
import { CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ResizableSwappableCard } from "./ResizableSwappableCard";
import { D3BarChart, D3ResponsiveContainer } from "../../charts/D3ChartUtils";

interface UserGrowthChartProps {
  newUsersTimeline: Array<{ date: string; count: number }>;
  stats: {
    newUsersWeek: number;
    newUsersMonth: number;
    newUsersYear: number;
  };
  rearrangingEnabled: boolean;
  onRemove?: (id: string) => void;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  onResize?: (id: string, newSize: 'small' | 'medium' | 'large' | 'xlarge') => void;
}

export function UserGrowthChart({ 
  newUsersTimeline, 
  stats, 
  rearrangingEnabled, 
  onRemove,
  size = 'medium',
  onResize
}: UserGrowthChartProps) {
  // Transform data for D3 charts
  const chartData = newUsersTimeline.length > 0
    ? newUsersTimeline.map(item => ({ name: item.date, value: item.count }))
    : [
        { name: 'Mon', value: 3 },
        { name: 'Tue', value: 1 },
        { name: 'Wed', value: 5 },
        { name: 'Thu', value: 2 },
        { name: 'Fri', value: 4 },
        { name: 'Sat', value: 7 },
        { name: 'Sun', value: 8 }
      ];
  
  console.log("UserGrowthChart data:", chartData);

  return (
    <ResizableSwappableCard 
      id="user-growth" 
      size={size}
      showHandle={rearrangingEnabled} 
      showResizeControl={rearrangingEnabled}
      onRemove={rearrangingEnabled ? onRemove : undefined}
      onResize={onResize ? (newSize) => onResize("user-growth", newSize) : undefined}
    >
      <CardHeader>
        <CardTitle>User Growth</CardTitle>
        <CardDescription>New users over time</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <D3ResponsiveContainer width="100%" height="100%">
            <D3BarChart
              data={chartData}
              color="#8884d8"
              valueFormatter={(value) => `${value} users`}
              margin={{ top: 20, right: 30, bottom: 50, left: 40 }}
            />
          </D3ResponsiveContainer>
        </div>
        <div className="mt-4 grid grid-cols-3 gap-2 text-center">
          <div>
            <p className="text-sm font-medium">This Week</p>
            <p className="text-2xl font-bold">{stats.newUsersWeek}</p>
          </div>
          <div>
            <p className="text-sm font-medium">This Month</p>
            <p className="text-2xl font-bold">{stats.newUsersMonth}</p>
          </div>
          <div>
            <p className="text-sm font-medium">This Year</p>
            <p className="text-2xl font-bold">{stats.newUsersYear}</p>
          </div>
        </div>
      </CardContent>
    </ResizableSwappableCard>
  );
}
